import * as configs from '@/configs/routes.config'
import * as routesTitles from '@/configs/translates.config'

import Login from '@/pages/Login.vue'
import Preview from '@/pages/Preview.vue'
import Dashboard from '@/pages/Dashboard.vue'
import Categories from '@/pages/categories/Categories.vue'
import Sets from '@/pages/grouping-pages/Sets.vue'
import Category from '@/pages/categories/Category.vue'
import Filters from '@/pages/grouping-pages/Filters.vue'
import Keywords from '@/pages/grouping-pages/Keywords.vue'
import Products from '@/pages/products/Products.vue'
import Product from '@/pages/products/Product.vue'
import news from '@/pages/news/News.vue'
import NewsIndex from '@/pages/news/NewsIndex.vue'
import Albums from '@/pages/albums/Albums.vue'
import Orders from '@/pages/orders/Orders.vue'
import Order from '@/pages/orders/Order.vue'
import Users from '@/pages/users/Users.vue'
import Slider from '@/pages/Sliders.vue'
import Subscriptions from '@/pages/users/Subscriptions.vue'
import AboutUs from '@/pages/AboutUs.vue'
import SEOpage from '@/pages/seo/SEOpage.vue'

const routes = [
	/* dashboard */
	{
		path: `/${configs.dashboard.inPathName}`,
		name: configs.dashboard.name,
		component: Dashboard,
		title: routesTitles.dashboard,
		isAddEditPage: configs.dashboard.isAddEditPage
	},
	/* sets */
	{
		path: `/${configs.sets.inPathName}`,
		name: configs.sets.name,
		component: Sets,
		title: routesTitles.sets,
		isAddEditPage: configs.sets.isAddEditPage
	},
	/* categories */
	{
		path: `/${configs.categories.inPathName}`,
		name: configs.categories.name,
		component: Categories,
		title: routesTitles.categories,
		isAddEditPage: configs.categories.isAddEditPage
	},
	/* category */
	{
		path: `/${configs.category.inPathName}/:id?`,
		name: configs.category.name,
		component: Category,
		title: routesTitles.category,
		isAddEditPage: configs.category.isAddEditPage
	},
	/* filters */
	{
		path: `/${configs.filters.inPathName}`,
		name: configs.filters.name,
		component: Filters,
		title: routesTitles.filters,
		isAddEditPage: configs.filters.isAddEditPage
	},
	/* keywords */
	{
		path: `/${configs.keywords.inPathName}`,
		name: configs.keywords.name,
		component: Keywords,
		title: routesTitles.keywords,
		isAddEditPage: configs.keywords.isAddEditPage
	},
	/* products */
	{
		path: `/${configs.products.inPathName}`,
		name: configs.products.name,
		component: Products,
		title: routesTitles.products,
		isAddEditPage: configs.products.isAddEditPage
	},
	/* product */
	{
		path: `/${configs.product.inPathName}/:slug?/:id?`,
		name: configs.product.name,
		component: Product,
		title: routesTitles.product,
		isAddEditPage: configs.product.isAddEditPage
	},
	/* news */
	{
		path: `/${configs.news.inPathName}`,
		name: configs.news.name,
		component: news,
		title: routesTitles.news,
		isAddEditPage: configs.news.isAddEditPage
	},
	/* newsIndex */
	{
		path: `/${configs.newsIndex.inPathName}/:slug?/:id?`,
		name: configs.newsIndex.name,
		component: NewsIndex,
		title: routesTitles.newsIndex,
		isAddEditPage: configs.newsIndex.isAddEditPage
	},
	/* orders */
	{
		path: `/${configs.orders.inPathName}`,
		name: configs.orders.name,
		component: Orders,
		title: routesTitles.orders,
		isAddEditPage: configs.orders.isAddEditPage
	},
	/* order */
	{
		path: `/${configs.order.inPathName}/:id`,
		name: configs.order.name,
		component: Order,
		title: routesTitles.order,
		isAddEditPage: configs.order.isAddEditPage
	},
	/* albums */
	{
		path: `/${configs.albums.inPathName}`,
		name: configs.albums.name,
		component: Albums,
		title: routesTitles.albums,
		isAddEditPage: configs.albums.isAddEditPage
	},
	/* sliders */
	{
		path: `/${configs.sliders.inPathName}`,
		name: configs.sliders.name,
		component: Slider,
		title: routesTitles.sliders,
		isAddEditPage: configs.sliders.isAddEditPage
	},
	/* users */
	{
		path: `/${configs.users.inPathName}`,
		name: configs.users.name,
		component: Users,
		title: routesTitles.users,
		isAddEditPage: configs.users.isAddEditPage
	},
	/* subscriptions */
	{
		path: `/${configs.subscriptions.inPathName}`,
		name: configs.subscriptions.name,
		component: Subscriptions,
		title: routesTitles.subscriptions,
		isAddEditPage: configs.subscriptions.isAddEditPage
	},
	/* about us */
	{
		path: `/${configs.aboutUs.inPathName}`,
		name: configs.aboutUs.name,
		component: AboutUs,
		title: routesTitles.aboutUs,
		isAddEditPage: configs.aboutUs.isAddEditPage
	},
	/* seo */
	{
		path: `/${configs.SEO.inPathName}`,
		name: configs.SEO.name,
		component: SEOpage,
		title: routesTitles.SEO,
		isAddEditPage: configs.SEO.isAddEditPage
	}
];

const availableRoute = [
	/* login */
	{
		path: `/${configs.login.inPathName}`,
		name: configs.login.name,
		component: Login,
		title: routesTitles.login,
		isAddEditPage: configs.login.isAddEditPage
	},
	
	/* preview */
	{
		path: `/${configs.preview.inPathName}`,
		name: configs.preview.name,
		component: Preview,
		title: routesTitles.preview,
	},
	
	{
		path: '*',
		redirect: '/'
	}
];

Object.keys(configs).filter(key => configs[key].show).forEach(key => {
	availableRoute.push(routes.find(route => route.name === configs[key].name));
})

export default availableRoute